import React from "react";
import { Container, Row, Col, Card, Button, Badge, Nav } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useHistory } from "react-router-dom";
import MyImage from "./Img/image.png";

const EsraProduct = () => {
  const history = useHistory();
  const ProductPage = () => history.push("/pricing");
  return (
    <div>
      <Navbar />

      {/* HERO SECTION */}
      <div className="py-5 bg-light">
        <Container className="text-center py-4">
          <h1
            className="fw-bold display-5 pt-5 mb-3"
            style={{ color: "#6969B3" }}
          >
            The Professional’s Edge
          </h1>
          <p className="lead text-muted">
            Advanced Tools for the Full E&S Lifecycle
          </p>
        </Container>
      </div>

      <Container className="py-5" style={{ paddingLeft: "50px" }}>
        {/* ================= myESRA ================= */}
        <Row className="align-items-center mb-5">
          <Col lg={6}>
            <h2 className="fw-bold mb-3">myESRA</h2>
            <p className="text-muted fs-5">
              Your AI-Powered E&S Research Assistant
            </p>
            <p>
              Fine-tuned on over 20 years of E&S project documents, legislation,
              and policies — built to help professionals reclaim time and
              increase impact.
            </p>

            <ul className="list-unstyled mt-4">
              <li className="mb-2">✔ Turnkey Knowledge Base</li>
              <li className="mb-2">✔ Verified Results with Citations</li>
              <li className="mb-2">✔ Direct File Interaction</li>
              <li className="mb-2">✔ Voice Command Integration</li>
              <li className="mb-2">✔ Accurate & Specialized Automation</li>
            </ul>
          </Col>

          <Col lg={6} className="order-lg-1">
            <Card className="border-0 shadow-lg p-4 text-center">
              {/* Video Section */}
              <div className="ratio ratio-16x9 mb-4">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                  className="w-100 rounded-4 shadow"
                >
                  <source
                    src="https://d22xlxg1ko514l.cloudfront.net/uat/videos/myESRA_2025-05-27.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Card>
          </Col>
        </Row>

        {/* ================= PRICING ================= */}
        <Row className="text-center mb-4">
          <Col>
            <h3 className="fw-bold">Pricing & Access</h3>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          {/* Weekly */}
          <Col md={4}>
            <Card className="h-100 shadow-sm border-0 text-center p-4">
              <h6 className="text-muted">Weekly Pass</h6>
              <h2 className="fw-bold my-3">€90</h2>
              <p className="text-muted">24-hour chatbot access</p>
              <p className="text-muted">Unlimited questions</p>
              <p className="text-muted">Full knowledge base</p>
              <Button
                variant="outline-primary"
                className="mt-3"
                onClick={ProductPage}
              >
                Get Started
              </Button>
            </Card>
          </Col>

          {/* Monthly - Highlight */}
          <Col md={4}>
            <Card className="h-100 shadow-lg text-center p-4">
              <div
                className="mb-2"
                style={{
                  backgroundColor: "#6969B3",
                  color: "white",
                  borderRadius: "8px",
                }}
              >
                Most Popular
              </div>
              <h6 className="text-muted">Monthly Pass</h6>
              <h2 className="fw-bold my-3">€250</h2>
              <p className="text-muted">30-day chatbot access</p>
              <p className="text-muted">Unlimited questions</p>
              <p className="text-muted">Priority troubleshooting</p>
              <Button
                style={{ backgroundColor: "#6969B3" }}
                className="mt-3"
                onClick={ProductPage}
              >
                Choose Plan
              </Button>
            </Card>
          </Col>

          {/* Annual */}
          <Col md={4}>
            <Card className="h-100 shadow-sm border-0 text-center p-4">
              <h6 className="text-muted">Annual</h6>
              <h2 className="fw-bold my-3">€2,500</h2>
              <p className="text-muted">Full year priority access</p>
              <p className="text-muted">Best value for teams</p>
              <p className="text-muted">Full feature suite</p>
              <Button
                variant="outline-primary"
                className="mt-3"
                onClick={ProductPage}
              >
                Get Annual
              </Button>
            </Card>
          </Col>
        </Row>

        {/* ================= privatESRA ================= */}
        <Row className="align-items-center mb-5">
          <Col lg={6} className="order-lg-2">
            <h2 className="fw-bold mb-3">privatESRA</h2>
            <p className="text-muted fs-5">Your Private Research Assistant</p>
            <p>
              Built for confidential workflows, ESDD reviews, and secure survey
              analysis. You remain in full control of your data.
            </p>

            <ul className="list-unstyled mt-4">
              <li className="mb-2">✔ Secure & Private Architecture</li>
              <li className="mb-2">✔ Interactive Canvas & Report Editor</li>
              <li className="mb-2">✔ Quick IFC Benchmarking</li>
              <li className="mb-2">✔ Multi-Document Intelligence</li>
              <li className="mb-2">✔ Voice Command Modes</li>
            </ul>
          </Col>

          <Col lg={6} className="order-lg-1">
            <Card className="border-0 shadow-lg p-4 text-center">
              {/* Video Section */}
              <div className="ratio ratio-16x9 mb-4">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                  className="w-100 rounded-4 shadow"
                >
                  <source
                    src="https://d22xlxg1ko514l.cloudfront.net/uat/videos/PrivatESRA_2025-07-30.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* ================= ENTERPRISE CTA ================= */}
      <div
        className="text-white py-5 text-center"
        style={{ backgroundColor: "#6969B3" }}
      >
        <Container>
          <h3 className="fw-bold mb-3">
            Enterprise Solutions for Corporate Teams
          </h3>
          <p className="mb-4">
            Best suited for organizations and teams of 10+ users.
          </p>
          <Button
            size="lg"
            variant="light"
            href="mailto:info@essolutions.ai?subject=Enterprise%20Quote%20Inquiry"
          >
            Contact Us for an Enterprise Quote
          </Button>
        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default EsraProduct;
